<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div
        data-slot="sheet-header"
        :class="
            cn(
                'flex h-18 flex-col justify-center gap-1.5 border-b p-4',
                props.class
            )
        "
    >
        <slot />
    </div>
</template>
